// extracted by mini-css-extract-plugin
module.exports = {"OrderItem":"Order_OrderItem__1pvzP"};